/* istanbul ignore file */
import { mainApi } from "config";
import { getProgress, IProgressState } from "infrastructure/helpers/common";
import { getClientFor } from "infrastructure/http";
import { IApiError } from "ui/shared/models/common";

export interface ITranslationUploadResponseError {
  message: string;
  property?: string;
}

export interface ITranslationUploadResponseItem {
  uniqueId: string;
  messageId: string;
  messageTranslation: string;
  locale: string;
  industry: string;
  error: IApiError;
}

const getApiProvider = () => {
  return {
    uploadTranslation: async (file: File, onProgress: (currentProgress: IProgressState) => void): Promise<ITranslationUploadResponseItem[]> => {
      const config = {
        onUploadProgress: function(progressEvent) {
          onProgress(getProgress(progressEvent.loaded, progressEvent.total));
        }
      };

      const formData = new FormData();
      formData.append("file", file);

      return (await getClientFor(mainApi.name).post<ITranslationUploadResponseItem[]>("messages/translations/upload", formData, config)).data;
    }
  };
};

export const translationUploadApi = getApiProvider();
